export { PrinterBusyError } from './printer-busy.error';
export { PrinterUncertainError } from './printer-uncertain.error';
export { PrinterNotReadyError } from './printer-not-ready.error';
export { PrinterRetryableError } from './printer-retryable.error';
export { isStarBusyError } from './star-busy-detector';
export { isStarPostWriteDisconnect, isStarPortOpenFailure, isStarLegacyPostWriteStatus, starLegacyPostWriteReason } from './star-uncertain-detector';
export * from './star-print-outcome';
export * from './print-failure-reason';
